import { z } from "zod"
import { ChildrenContainerOptionsV1, ContainerOptionsV1 } from "../containerOptions"
import { Element } from "../element"

// Version 1 ---------------------
export const ListV2SettingsV1 = z.object({
  horizontal: z.union([z.literal(true), z.literal(false)]),
  snap: z.union([z.literal(true), z.literal(false)]),
  hasItemPadding: z.union([z.literal(true), z.literal(false)]),
  fullHeight: z.union([z.literal(true), z.literal(false)]),
  height: z.string(),
  indicatorBottomPadding: z.union([z.literal(true), z.literal(false)]),
  indicatorTopPadding: z.union([z.literal(true), z.literal(false)]),
  indicatorColor: z.string(),
  style: z.string(),
})

export type TListV2SettingsV1 = z.infer<typeof ListV2SettingsV1>

export const ListV2ElementV1 = z.object({
  id: z.string(),
  name: z.literal("listV2"),
  settings: ListV2SettingsV1,
  container: ContainerOptionsV1,
  children: z.lazy(() => z.array(Element)),
  childrenContainer: ChildrenContainerOptionsV1,
})

export type TListV2ElementV1 = z.infer<typeof ListV2ElementV1>

// Latest ---------------------
export const ListV2Settings = ListV2SettingsV1
export type TListV2Settings = TListV2SettingsV1
export const ListV2Element = ListV2ElementV1
export type TListV2Element = TListV2ElementV1
